<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.17238 12.9297C10.352 12.9297 12.9297 10.352 12.9297 7.17238C12.9297 3.99271 10.352 1.41508 7.17238 1.41508C3.99271 1.41508 1.41508 3.99271 1.41508 7.17238C1.41508 10.352 3.99271 12.9297 7.17238 12.9297ZM7.17238 14.3448C11.1336 14.3448 14.3448 11.1336 14.3448 7.17238C14.3448 3.21118 11.1336 0 7.17238 0C3.21118 0 0 3.21118 0 7.17238C0 11.1336 3.21118 14.3448 7.17238 14.3448Z"
    fill="currentColor" />
</svg>
